import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import TmwApi from '../../containers/Ticket/TmwApi';
import FormTypeToSelect from '../form/FormTypeToSelect';

class TmwConsigneeSelect extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			consigneeCustomers: [],
		};
	}
	componentDidMount() {
		const { getConsigneeCustomerList } = this.props;

		getConsigneeCustomerList({
			callback: (err, r) => {
				if (err) {
					return console.error(err);
				}
				this.setState({ consigneeCustomers: r.consigneeCustomers });
			},
		});
	}

	render() {
		let { value, consigneeFilter } = this.props;
		const { consigneeCustomers = [] } = this.state;
		const filter = consigneeFilter ? _.keyBy(consigneeFilter) : undefined;

		let options = consigneeCustomers.map((consigneeCustomer) => {
			const { consigneeCompanyId, consigneeCompanyName } = consigneeCustomer;
			if (filter && !filter[consigneeCompanyId]) {
				// gets rid of previously selected values
				if (_.isArray(value) && _.includes(value, consigneeCompanyId)) {
					value = _.remove(value, consigneeCompanyId);
				}
				return null;
			}

			return {
				value: consigneeCompanyId,
				label: `${consigneeCompanyName} (${consigneeCompanyId})`,
			};
		});

		options = _.sortBy(_.compact(options), 'display');

		return <FormTypeToSelect {...this.props} options={options} />;
	}
}

TmwConsigneeSelect.propTypes = {
	label: PropTypes.string,
	value: PropTypes.string,
	path: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	error: PropTypes.string,

	getConsigneeCustomerList: PropTypes.func.isRequired,

	classes: PropTypes.object,
	helpText: PropTypes.string,
	consigneeFilter: PropTypes.array,
};

TmwConsigneeSelect.defaultProps = {
	label: 'Consignee Customer',
	consigneeCustomers: [],
};

export default TmwApi(TmwConsigneeSelect);
